import { IconStatusIndicator } from '@components/icons/status-indicator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { Color } from '@styles/theme';

export type StatusOptionLabelProps = {
  text: string;
  color: Color;
};

export const StatusOptionLabel = (props: StatusOptionLabelProps) => {
  const { text, color } = props;
  return (
    <Stack orientation="horizontal" align="center" space={1}>
      <IconStatusIndicator color={color} />
      <Text text={text} />
    </Stack>
  );
};
